import * as React from 'react';
import {AnnualPolicyInfo} from "@ferry/journey-services";
import {resourcesHelper} from "@ferry/portal-core";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import NotificationModal from "../../../../../components/modals/NotificationModal";

interface IProps {
    policyCancelled: boolean,
    renewalPaymentFailed?: boolean,
    annualPolicyInfo?: AnnualPolicyInfo,
    paymentType?: string,
    interaction?: any,
    canChangePaymentDate?: boolean,
    paymentDay: string
    annualToMonthly?: boolean;
}

interface IState {
    showAlert: boolean
}

export class PaymentDaySection extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showAlert: false,
        };
    }

    public render() {
        const {annualPolicyInfo, interaction} = this.props;
        let paymentDayToRender: string;
        let changeDateJourneyLink: string;
        let hasDebt: boolean = false;

        if (interaction) {
            if (this.props.annualToMonthly) {
                paymentDayToRender = this.convertWolfPaymentDate(this.props.paymentDay);
                changeDateJourneyLink = `/dashboard/account/changeRenewalPaymentDay/${interaction.agreementNumber}`;
            } else {
                paymentDayToRender = this.convertWolfPaymentDate(this.props.paymentDay);
                changeDateJourneyLink = `/dashboard/account/changePaymentDay/${interaction.agreementNumber}`;
                hasDebt = annualPolicyInfo?.hasDebt as boolean;
            }

            const disableButton = this.disableButton(hasDebt);

            return (
                <div className="payment-day-section">
                    <div className="d-flex flex-row">
                        <div className="d-none d-md-flex flex-column">
                            <img className="icon-panel mb-0"
                                 src={`/${resourcesHelper.THEME_PATH}/img/payment-day.svg`}
                                 alt="Calendar icon" aria-label="Calendar icon"/>
                        </div>
                        <div className="d-flex flex-column justify-content-center w-100">
                            <div className="d-md-none d-flex align-i-center mb-3">
                                <img className="icon-panel mb-0"
                                     src={`/${resourcesHelper.THEME_PATH}/img/payment-day.svg`}
                                     alt="Calendar icon" aria-label="Calendar icon"/>
                                <h2 className="font-family-display font-weight-bold mb-0">
                                    Payment day
                                </h2>
                            </div>
                            <div className="d-flex flex-column">
                                <div className="d-flex justify-content-between align-items-center mb-4">
                                    <h2 className="font-family-display font-weight-bold d-md-block d-none mb-0">
                                        Payment day
                                    </h2>
                                    {this.props.annualToMonthly &&
                                        <div className="bubble-container">
                                            <div className="corner-bubble">Renewal only</div>
                                        </div>
                                    }
                                </div>
                                <p>Every <span className="font-weight-bold">{paymentDayToRender!}</span> of the month
                                </p>
                                <button
                                    id="addNewCard"
                                    disabled={disableButton}
                                    className={`mb-1 mt-1 change-day-button ${disableButton ? "btn btn-primary btn-disabled" : "btn btn-blue-dashboard"}`}
                                    onClick={e =>
                                        this.handleClick(e, disableButton, changeDateJourneyLink)}>
                                    Change day
                                </button>
                                <NotificationModal show={this.state.showAlert} hide={this.hideAlert}>
                                    {!this.props.canChangePaymentDate ? "This action is not allowed"
                                        : (this.props.policyCancelled ?
                                            "Due to policy cancellation this action is not allowed" :
                                            "Due to missed payment this action is not allowed")}
                                </NotificationModal>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return <React.Fragment/>
        }
    }

    private convertWolfPaymentDate = (day: string): string => {
        return PluginTemplates.convertWolfPaymentDate(day);
    }

    private disableButton(hasDebt: boolean) {
        return this.props.policyCancelled || this.props.renewalPaymentFailed || hasDebt || !this.props.canChangePaymentDate;
    }

    private handleClick = (event: any, renewalFailed: boolean, changeDateJourneyLink: string): void => {
        event.preventDefault();
        if (renewalFailed) {
            this.setState({showAlert: true});
        } else {
            window.location.assign(changeDateJourneyLink);
        }
    };

    private hideAlert = (): void => {
        this.setState({showAlert: false});
    }
}
